import React, { Component } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Modal } from 'react-bootstrap';
import StartEndDate from '../components/startEndDate/StartEndDate';
import Product from '../components/product/Product';
import DisplayType from '../components/displayType/DisplayType';
import AgentCodeName from '../components/agentCodeName/AgentCodeName';
import config from '../../config/config';
import { momentToISOString } from '../../utils/dateUtils'
import ProgressBar from '../components/progressBar/ProgressBar';

const appUrlPath = `/${config.appUrlPath}`;
const FileDownload = require('react-file-download');

export class AgentSummaryReport extends Component {
  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';
    this.state = {
      redirect: false,
      isLoading: false,
      startDate: null,
      endDate: null,
      previousFrom: null,
      previousTo: null,
      agentCode,
      agentName,
      role,
      product: '',
      displayType: 'html',
      showModal: false,
      message: ''
    };

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this);
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    this.handleChangeProduct = this.handleChangeProduct.bind(this);
    this.handleChangeDisplayType = this.handleChangeDisplayType.bind(this);
    this.handleChangePreviousFrom = this.handleChangePreviousFrom.bind(this);
    this.handleChangePreviousTo = this.handleChangePreviousTo.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);
    this.close = this.close.bind(this);

    axios.get(`${appUrlPath}/getCsrfToken`, {
      params: {},
      headers: { 'ACTION-LOG': 'Access Agent Summary Report Page' }
    })
    .then((res) => {
      axios.defaults.headers.common = {
        'CSRF-TOKEN': res.data.csrfToken
      };
    })
    .catch(() => {
    });
  }

  componentWillMount() {
  }

  handleChangeStartDate(date) {
    if (date != null) {
      this.setState({
        startDate: momentToISOString(date)
      });
    }
  }

  handleChangeEndDate(date) {
    if (date != null) {
      this.setState({
        endDate: momentToISOString(date)
      });
    }
  }

  handleChangePreviousFrom(date) {
    if (date != null) {
      this.setState({
        previousFrom: momentToISOString(date)
      });
    }
  }

  handleChangePreviousTo(date) {
    if (date != null) {
      this.setState({
        previousTo: momentToISOString(date)
      });
    }
  }

  handleChangeProduct(e) {
    this.setState({
      product: e.target.value
    });
  }

  handleChangeDisplayType(e) {
    this.setState({
      displayType: e.target.value
    });
  }

  handleChangeAgentCode(e) {
    const agentCode = e.target.value;
    this.setState({
      agentCode
    });
  }

  handleGetAgentName(e) {
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      this.setState({
        agentName: res.data.agentName
      })
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    // validation
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    const previousFrom = this.state.previousFrom;
    const previousTo = this.state.previousTo;
    const displayType = this.state.displayType;
    const responseType = displayType === 'excel' ? 'arraybuffer' : '';
    if (!startDate || !endDate) {
      this.setState({
        message: 'The start date or end date cannot be null.',
        showModal: true
      });
      return;
    } else if ((previousFrom == null && previousTo != null) ||
        (previousFrom != null && previousTo == null)) {
      this.setState({
        message: 'The previous from or previous to cannot be null.',
        showModal: true
      });
      return;
    }
    this.setState({ isLoading: true })
    let myWindow = null;
    if (displayType != 'excel') {
      myWindow = window.open('', '_blank', '');
    }
    axios.post(`${appUrlPath}/generateAgentSummaryReport`, {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      previousFrom: this.state.previousFrom,
      previousTo: this.state.previousTo,
      agentCode: this.state.agentCode,
      agentName: this.state.agentName,
      product: this.state.product,
      displayType: this.state.displayType
    }, { responseType })
    .then((response) => {
      this.setState({ isLoading: false })
      if (displayType === 'excel') {
        FileDownload(response.data, 'report.xlsx');
      } else {
        //const myWindow = window.open('', '_blank', '');
        myWindow.document.write(response.data);
      }
    })
    .catch((error) => {
      let errorMsg = '';
      if (error.response) {
        errorMsg = error.response.data; 
      }
      if (myWindow) {
        myWindow.close();
      }
      this.setState({
        message: errorMsg || 'Generate Fail.',
        showModal: true,
        isLoading: false
      });
    });
  }

  handleClick() {
    window.location.assign('/en/motorb2b/home');
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}
        <h2 className="ebaoUtil__HeaderTwo">Agent Summary Transaction</h2>
        <h3 className="ebaoUtil__HeaderThree">Reporting Condition</h3>
        <Form horizontal onSubmit={this.handleSubmit}>
          <div className="ebaoUtil__Form-80">
             <StartEndDate
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                startDateLabel="Start Date*"
                endDateLabel="End Date*"
                handleChangeStartDate={this.handleChangeStartDate}
                handleChangeEndDate={this.handleChangeEndDate}
             />
             <StartEndDate
                startDate={this.state.previousFrom}
                endDate={this.state.previousTo}
                startDateLabel="Previous From"
                endDateLabel="Previous To"
                handleChangeStartDate={this.handleChangePreviousFrom}
                handleChangeEndDate={this.handleChangePreviousTo}
             />
             <AgentCodeName
                agentCode={this.state.agentCode}
                agentName={this.state.agentName}
                handleGetAgentName={this.handleGetAgentName}
                handleChangeAgentCode={this.handleChangeAgentCode}
                systemRole={this.state.role}
                required={false}
             />
             <Product handleChangeProduct={this.handleChangeProduct} productValue={this.state.product} />
             <DisplayType handleChangeDisplayType={this.handleChangeDisplayType} defaultDisplayType={this.state.displayType} />
             <FormGroup controlId="buttonGroup">
               <div className="ebaoUtil__ButtonGroup">
                 <button type="submit" className="btn btn-axa">Generate Report</button>{' '}
                 <button type="button" className="btn btn-axa" onClick={this.handleClick}>Exit</button>
               </div>
             </FormGroup>
          </div>
       </Form>
    </div>
    )
  }
}

export default AgentSummaryReport;



// WEBPACK FOOTER //
// ./src/app/pages/AgentSummaryReport.js